import $ from "jquery";

const wysiwyg = () => {
    // оборачиваем каждую таблицу в визиге
    $(".wysiwyg table").each(function () {
        $(this).wrap('<div class="scroll-table"></div>');
    });
};

export default wysiwyg;
